function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpringYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-557c78b1-bbfa-4c49-917f-175215715dc6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.42 68.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.29,3.74c2.32,.2,4.82,.51,6.51,2.11,1.98,1.87,2.24,4.88,2.34,7.61,.47,12.52,.36,25.05-.32,37.56-.14,2.61-.36,5.35-1.83,7.51-1.57,2.3-4.29,3.52-6.96,4.32-6.84,2.06-14.09,2.14-21.23,2.21-16.08,.15-32.25,.29-48.14-2.23-1.6-.25-3.27-.57-4.53-1.58-2.16-1.74-2.42-4.88-2.51-7.65-.19-6.17-.38-12.35-.57-18.52-.48-15.65,3.06-27.53,19.46-29.4,19.34-2.21,38.32-3.6,57.79-1.92Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.72,47.13c0-2.89,17.97-10.57,20.64-12.23,1.44-.9,2.98-1.91,3.55-3.51-8.36-3.64-16.73-7.27-25.1-10.9,0,3.88,.37,7.62,.54,11.44,.23,5.06,.35,10.13,.37,15.2Z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringYoutube);
export default __webpack_public_path__ + "static/media/spring - youtube.3b8ffe5cc681cbec65138e626aa88c4d.svg";
export { ForwardRef as ReactComponent };